import { render, staticRenderFns } from "./SettingControl.vue?vue&type=template&id=69c26e0e&scoped=true"
import script from "./SettingControl.vue?vue&type=script&lang=js"
export * from "./SettingControl.vue?vue&type=script&lang=js"
import style0 from "./SettingControl.vue?vue&type=style&index=0&id=69c26e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c26e0e",
  null
  
)

export default component.exports